import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Webinars from "@/pages/Webinars";

export const Route = createFileRoute("/en/webinars/")({
  head: () => buildRouteHead("/en/webinars"),
  component: Webinars,
});

